import { baseThemeValues } from 'constants/common';

const baseProps = {
  borderRadius: '15px',
  borderWidth: '2px',
  boxShadowWidth: '7px',
  fontFamily: baseThemeValues.inherit,
  fontSize: '14px',
  fontWeight: 400,
};

const labelBase = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '12px',
  fontWeight: 500,
};

export const radioSelectTheme = {
  checked: {
    base: {
      ...baseProps,
      bg: 'palette.transparent',
      borderColor: 'palette.primary.20',
      borderWidth: '7px',
      boxShadowColor: 'palette.transparent',
      text: 'palette.tertiary.95',
    },
    baseProps,
    disabled: {
      ...baseProps,
      bg: 'palette.transparent',
      borderColor: 'palette.neutral.40',
      borderWidth: '7px',
      boxShadowColor: 'palette.transparent',
      text: 'palette.neutral.40',
    },
    hover: {
      ...baseProps,
      bg: 'palette.transparent',
      borderColor: 'palette.primary.10',
      borderWidth: '7px',
      boxShadowColor: 'palette.tertiary.10',
      text: 'palette.tertiary.95',
    },
    pressed: {
      ...baseProps,
      bg: 'palette.transparent',
      borderColor: 'palette.primary.20',
      borderWidth: '7px',
      boxShadowColor: 'palette.tertiary.20',
      text: 'palette.tertiary.95',
    },
  },
  groupLabel: {
    ...labelBase,
    text: 'palette.tertiary.60',
  },
  notChecked: {
    base: {
      ...baseProps,
      bg: 'palette.transparent',
      borderColor: 'palette.tertiary.40',
      boxShadowColor: 'palette.transparent',
      text: 'palette.tertiary.95',
    },
    baseProps,
    disabled: {
      ...baseProps,
      bg: 'palette.transparent',
      borderColor: 'palette.neutral.40',
      boxShadowColor: 'palette.transparent',
      text: 'palette.neutral.40',
    },
    hover: {
      ...baseProps,
      bg: 'palette.tertiary.20',
      borderColor: 'palette.tertiary.50',
      boxShadowColor: 'palette.tertiary.10',
      text: 'palette.tertiary.95',
    },
    pressed: {
      ...baseProps,
      bg: 'palette.tertiary.20',
      borderColor: 'palette.tertiary.60',
      boxShadowColor: 'palette.tertiary.20',
      text: 'palette.tertiary.95',
    },
  },
};
